import React, { type DetailedHTMLProps, type HTMLAttributes, forwardRef } from "react";
import { SupText } from "../../../../components/UI/Text";
import { twJoin } from "tailwind-merge";

interface MaxButtonProps extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  visible: boolean;
}

export const MaxButton = forwardRef<HTMLElement, MaxButtonProps>(function MaxButtonComponent({ visible, className, ...restProps }, ref) {
  return visible ? (
    <SupText
      {...restProps}
      ref={ref}
      as="button"
      variant="caption"
      weight="bold"
      className={twJoin("underline text-primary-700 px-0.5", className)}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      MAX
    </SupText>
  ) : null;
});
